// See: https://stackoverflow.com/questions/6234773/can-i-escape-html-special-chars-in-javascript.
export const escapeHtml = (html: string): string => {
  const entityMap: { [key: string]: string } = {
    '"': '&quot;',
    '&': '&amp;',
    "'": '&#039;',
    '<': '&lt;',
    '>': '&gt;',
    '\\': '&bsol;',
  };

  return html.replace(/[&<>"'\\]/g, (s) => entityMap[s]);
};
